var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHighlight = function SvgHighlight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5L14.5 6C15.3284 5.17157 15.3284 3.82843 14.5 3C13.6716 2.17157 12.3284 2.17157 11.5 3L5 9.5V12.5H8Z",
    stroke: "#888EA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5H3C2.44772 15.5 2 15.9477 2 16.5C2 17.0523 2.44772 17.5 3 17.5H15C15.5523 17.5 16 17.0523 16 16.5C16 15.9477 15.5523 15.5 15 15.5Z",
    fill: "#888EA7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHighlight);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTIuNUwxNC41IDZDMTUuMzI4NCA1LjE3MTU3IDE1LjMyODQgMy44Mjg0MyAxNC41IDNDMTMuNjcxNiAyLjE3MTU3IDEyLjMyODQgMi4xNzE1NyAxMS41IDNMNSA5LjVWMTIuNUg4WiIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUgMTUuNUgzQzIuNDQ3NzIgMTUuNSAyIDE1Ljk0NzcgMiAxNi41QzIgMTcuMDUyMyAyLjQ0NzcyIDE3LjUgMyAxNy41SDE1QzE1LjU1MjMgMTcuNSAxNiAxNy4wNTIzIDE2IDE2LjVDMTYgMTUuOTQ3NyAxNS41NTIzIDE1LjUgMTUgMTUuNVoiIGZpbGw9IiM4ODhFQTciLz4KPC9zdmc+Cg==";